<template>
    <div class="inplay-details-page-section">
        <div class="container-fluid">
            <div class="input-field-section trm-condations-sec rule_info_wrapper">
                <div class="row">
                    <div class="col-12">
                        <template v-for="(rule, r_index) in siteRuleData" :key="r_index">
                            <template v-if="rule.type == 'General'">                            
                                <div class="menu-details-list all-rule" v-html="rule.content"></div>
                            </template>
                        </template>
                        <div class="back-modal" v-if="!siteRuleData?.filter(item => item.type == 'General')?.length">
                            <div class="mene-details information-modal-sec">
                                <div class="menu-details-list">
                                    {{ $t('no-rules-available', 'No rules available') }}.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Rules',
    data(){
        return{
            siteRuleData:null
        }
    },
    mounted(){
        this.getRules();
    },
    methods:{
        getRules() { 
            this.siteRuleData = this.$siteSettings?.data?.rules;
        },
    }

}
</script>

<style></style>